export const TEST_ID = 'privacyPolicyPage';
